import Platform from "../../../../libs/utility/Platform";
import { Theme } from "../../../components/constants";

export default {
    customPopupHeaderStyles:{
        padding: "10px 20px"
    },
    popupStyles: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: Theme.BACKGROUND_PRIMARY,
    },
    popupoOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 998,
    },
    popupChildrenStyles: {
        maxHeight: Platform.isMobileView() ? "100%" : "unset",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "30px",
        alignItems: "center",
    },
    titleIconDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        paddingRight: "150px",
    },
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: Platform.isMobileView() ? "100%" : "80%",
    },
    fancyRowFirst: {
        display: "flex",
        background: "#E5EEFA",
        padding: "20px",
        position: "relative",
        marginTop: "20px"
    },
    leftColumn: {
        display: "flex",
        flexDirection: "column",
        marginRight: "125px"
    },
    rightIcon: {
        position: "absolute",
        right: 0,
        bottom: 0,
        width: "170px",
    },
    fancyRowTitle: {
        color: Theme.PRIMARY
    },
    fancyRowSecond: {
        display: "flex",
        background: "#ECF8F1",
        padding: "20px",
        position: "relative",
        marginTop: "80px"
    },
    rightColumn: {
        display: "flex",
        flexDirection: "column",
        marginLeft: "170px"
    },
    leftIcon: {
        position: "absolute",
        left: 0,
        bottom: 0,
        width: "170px",
    },
    verticalSeparatorStyles: {
        borderRight: `1px solid ${Theme.PRIMARY}`,
    },
    rowWVerticalSeparator: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "7px",
        marginTop: "20px",
    },
    takeQuizTextStyles: {
        marginBottom: "2px",
        color: Theme.PRIMARY
    },
    buttonRows: {
        display: "flex",
        gap: "10px",
        marginTop: "10px",
    },
    paragraphText: {
        fontSize: "14px",
    },
    buttonStyle: {
        borderRadius: "5px"
    },
    whiteCardContainer:{
        background: "#ffffff",
        minHeight: "350px",
        marginTop: "20px",
        padding: "30px"
    },
    quizContainer: {
        marginTop: "25px",
    },
    quizQuestionContainer: {
        display: "flex",
        justifyContent: "space-between",
    },
    quizQuestionText: {
        color: Theme.PRIMARY,
    },
    quizOptionsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "30px",
        textAlign: "center",
    },
    quizOptions: {
        width: "300px",
        padding: "10px 0",
        border: "1px solid #54657E",
        borderRadius: "4px",
        cursor: "pointer",
    },
    selectedQuizOption: {
        border: `1px solid ${Theme.PRIMARY}`,
        boxShadow: `0px 2px 0px 0px ${Theme.PRIMARY}`,
        background: "#E2EDFF",
        color: Theme.PRIMARY,
    },
    navigationBtnsContainer: {
        marginTop: "60px",
        display: "flex",
        gap: "10px",
    },
    quizFinalResultContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px"
    },
    quizFinalResultIconStyles: {
        marginBottom: "20px",
    },
    quizFinalResultActionBtns: {
        display: "flex",
        gap: "10px"
    },
    fincenLogoContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    fincenLogo: {
        width: "78px",
    },
    noteDiv: {
        fontStyle: "italic",
        color: Theme.TEXT_DARK_GRAY,
        marginTop: "40px",
    },
    noteDivStar: {
        color: Theme.DANGER,
    }
}